import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    //redirect: '/oneThing',
    children:[{
      path: '/myMatters',
      name: '火化证明',
      component: () => import('../views/myMatters.vue'),
    },{
      path: '/bodyTransfer',
      name: '遗体接运',
      component: () => import('../views/bodyTransfer.vue'),
    },
    //   {
    //   path: '/oneThing',
    //   name: '身后一件事',
    //   component: () => import('../views/oneThing.vue'),
    // },
    {
      path: '/nav',
      name: '身后一件事',
      component: () => import('../components/nav.vue'),
    },
      {
      path: '/main1',
      name: 'main',
      component: () => import('../components/main1.vue'),
    },{
      path: '/selectBusiness',
      name: '选择业务',
      component: () => import('../views/selectBusiness.vue'),
    },{
      path: '/basicsForm',
      name: '基础信息填报',
      component: () => import('../views/basicsForm.vue'),
    },{
      path: '/infomationForm',
      name: '信息填报',
      component: () => import('../views/infomationForm.vue'),
    },{
      path: '/fileForm',
      name: '附件材料上传',
      component: () => import('../views/fileForm.vue'),
    },{
      path: '/succeed',
      name: '申报完成',
      component: () => import('../views/succeed.vue'),
    },]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
